import React, {useCallback, useEffect, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import XLSX from 'xlsx';

export default function (props) {
    const [files, setFiles] = useState([]);


    const convertToJson = (csv) => {
        var lines = csv.split("\n");

        var result = [];

        var headers = lines[0].split(",");

        for (var i = 1; i < lines.length; i++) {
            var obj = {};
            var currentline = lines[i].split(",");

            for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
            }

            result.push(obj);
        }
        //return result; //JavaScript object
        return JSON.stringify(result); //JSON
    }
    
    const {getRootProps, getInputProps} = useDropzone({
      accept: ['text/*','.xls','.xlsx'],
      onDrop: acceptedFiles => {
        let totalFiles;
        if (files.length > 0) {
          totalFiles = [...files,...acceptedFiles]
        } else {
          totalFiles = acceptedFiles;
        }
      
        if (props.convertTo === 'json') {
            const file = totalFiles[0];
            const reader = new FileReader();
            reader.onload = (evt) => {
                /* Parse data */
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
                /* Update state */
                props.onDrop(JSON.parse(convertToJson(data))); // shows data in json format
            };
            reader.readAsBinaryString(file);
                
        } else {
            props.onDrop(totalFiles);
        }
        
        setFiles(totalFiles.map(file => Object.assign(file, {
          preview: URL.createObjectURL(file)
        })));
      }
    });
    
  
    useEffect(() => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);


    return (
        <div>
            {
                props.labelHidden ? null :
                    <label className="block text-sm font-medium text-gray-700">
                        {props.label}
                    </label>

            }
            <section className="container text-sm text-gray-600">
                <div {...getRootProps({className: 'dropzone'})}>
                    <div className=" mt-1 text-center justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                        <svg
                            className="mx-auto h-12 w-12 text-gray-400"
                            stroke="currentColor"
                            fill="none"
                            viewBox="0 0 48 48"
                            aria-hidden="true"
                        >
                            <path
                                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <input {...getInputProps()} />
                        <div className="flex-row">
                            <text className="relative cursor-pointer bg-white rounded-md font-medium text-primary hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                Upload a file
                            </text>
                            <text className="pl-1">or drag and drop</text>
                        </div>
                        
                        <p className="text-xs text-gray-500">{props.info}</p>
                    </div>
                </div>
            </section>
        </div>
    )
};
